// Body of the lookup-orders-by-email ("Check Your Order Status") page: the
// legacy sealy account-page layout -- the brand heading, the email form
// rendered as a native React field tree, and the decorative account image.
// The help/heading copy is the sealy legacy template's own (this site's copy
// differs from the shared LookupOrdersByEmailBody defaults); sealy serves
// en-us only, so the plain literals match the legacy {% trans %} output.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_FIELD_SUBMIT_CLASS_NAME,
    FORM_HELP_TEXT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountSplitShell } from "../AccountSplitShell";

type IProps = Immutable<templates.LookupOrdersByEmailDocumentTemplate>;

export const LookupOrdersByEmailBody = (props: IProps): React.JSX.Element => {
    return (
        <AccountSplitShell
            heading="Your Sealy® Orders"
            sectionHeading="Check Your Order Status"
        >
            <div>
                <form
                    id="lookup-orders-by-email-form"
                    className="js-kuid-form"
                    action={props.action_url}
                    method="post"
                >
                    <p
                        className={FORM_HELP_TEXT_CLASS_NAME}
                        data-testid="form-help-text"
                    >
                        Please enter the email address associated with your
                        order. If we&rsquo;re able to locate an order associated
                        with your email address, we&rsquo;ll send you a link to
                        access your order history.
                    </p>
                    <CSRFToken />
                    <FormFields
                        fields={props.fields}
                        field_labels={props.field_labels}
                        field_errors={props.field_errors}
                        non_field_errors={props.non_field_errors}
                    />
                    <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                        <input
                            type="submit"
                            className="button button--full-width"
                            value="Send Verification Email"
                        />
                    </div>
                </form>
            </div>
        </AccountSplitShell>
    );
};
